import {StringUtils} from "@/string-utils";

export class UserInfoModel {

    // 名前
    name: string = "";

    // 名前かな
    kana: string = "";

    // 性別
    gender: string = "";

    // 生年月日
    birthday: string = "";

    // 電話番号
    tel: string = "";

    // 郵便番号
    postalCode: string = "";

    // 都道府県
    prefecture: string = "";

    // 市区町村
    city: string = "";

    // 番地
    streetAddress: string = "";

    // メールアドレス
    mail: string = "";

    public copy(obj: UserInfoModel) {
        if (obj) {
            this.name = obj.name;
            this.kana = obj.kana;
            this.gender = obj.gender || "";
            this.birthday = obj.birthday;
            this.tel = obj.tel;
            this.postalCode = obj.postalCode;
            this.prefecture = obj.prefecture;
            this.city = obj.city;
            this.streetAddress = obj.streetAddress;
            this.mail = obj.mail;
        }
    }

    /** 郵便番号を返却 */
    public getPostalCode(): string  {
        let code = this.postalCode;
        if (code && code.length === 7) {
            return `${code.substring(0, 3)}-${code.substring(3)}`;
        } else {
            return code;
        }
    }

    /**
     * トリムします。対象は以下の項目です。
     * ・名前
     * ・名前（カナ）
     * ・番地
     */
    public trim(): UserInfoModel {
        this.name = StringUtils.trim(this.name);
        this.kana = StringUtils.trim(this.kana);
        this.streetAddress = StringUtils.trim(this.streetAddress);
        return this;
    }
}